import { FormEvent, ReactElement, useState } from "react";
import { Link } from "react-router-dom";
import { Form, FormField } from "@justworkshr/milo-form";
import { Button } from "@justworkshr/milo-core";

import AuthPageTemplate from "pages/register/components/authPageTemplate/AuthPageTemplate";
import AccessOptionGroup from "./components/accessOptionGroup/accessOptionGroup";
import FooterButtons from "pages/register/components/footerButtons/FooterButtons";

import { ReactComponent as CelebratoryHornIcon } from "./icons/celebratory-horn.svg";

const LoginOrRegister = (): ReactElement => {
  const [selectionURL, setSelectionURL] = useState("");

  const onChange = (newSelection: string) => setSelectionURL(newSelection);

  const handleFormSubmit = (e: FormEvent<HTMLFormElement>) =>
    e.preventDefault();

  const titleCopy = `We're here for small businesses`;
  const descriptionCopy =
    "Leveling the playing field with payroll, benefits, and other seamless HR tools.";

  return (
    <AuthPageTemplate
      header={{
        title: titleCopy,
        description: descriptionCopy,
        icon: <CelebratoryHornIcon />,
      }}
    >
      <Form onSubmit={handleFormSubmit}>
        <FormField label="Select one to get started" required={true}>
          <AccessOptionGroup onChange={onChange} />
        </FormField>

        <FooterButtons>
          <Link to={selectionURL}>
            <Button
              rightIcon="arrow-right"
              type={"button"}
              disabled={!selectionURL}
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            >
              Next
            </Button>
          </Link>
        </FooterButtons>
      </Form>
    </AuthPageTemplate>
  );
};

export default LoginOrRegister;
